export enum Pages {
  DASHBOARD = 'dashboard',
  CALENDAR = 'calendar',
  USER_SETTINGS = 'user-settings',
  TENANT_SETTINGS = 'tenant-settings',
  ROOM_SETTINGS = 'room-settings',
  SHIFT_SETTINGS = 'shift-settings',
  EMPLOYEE_SETTINGS = 'employee-settings',
  SERVICE_SETTINGS = 'service-settings',
}

export enum CustomEvents {
  OPEN_BOOKING_MODAL = 'open-booking-modal',
  OPEN_BOOKING_MODAL_EDIT = 'open-booking-modal-edit',
  OPEN_FAST_CHECKIN_MODAL = 'open-fast-checkin-modal',
  OPEN_CUSTOM_MAIL_MODAL = 'open-custom-mail-modal',
  OPEN_PHONE_CALL = 'open-phone-call',
  OPEN_ABSENCE_MODAL = 'open-absence-modal',
  OPEN_FOOD_EVENT_MODAL = 'open-food-event-modal',
  OPEN_EDIT_EVENT_MODAL = 'open-edit-event-modal',
  OPEN_DELETE_ABSENCE_MODAL = 'open-delete-absence-modal',
  OPEN_DELETE_EVENT_MODAL = 'open-delete-event-modal',
  REFRESH_BOOKINGS = 'refresh-bookings',
  COPY_DASHBOARD_LINK = 'copy-dashboard-link',
  SEARCH_BOOKINGS = 'search-bookings',
  FILTER_BOOKINGS = 'filter-bookings',
  FILTER_ROOMS = 'filter-rooms',
  SHOW_MORE_CUSTOMER_DETAILS = 'show-more-customer-details',
  CHANGE_STATUS_DASHBOARD = 'change-status-dashboard',
  TOGGLE_STATISTICS = 'toggle-statistics',
}
